// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoPlayer_videoContainer__uPGEZ","videoOverlay":"VideoPlayer_videoOverlay__G7LSb","hidden":"VideoPlayer_hidden__H+LBr"};